// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const browser = "UserAgentBadge__browser__+hd-J";
export const browserBadge = "UserAgentBadge__browserBadge__EGaEX";
export const caption = "UserAgentBadge__caption__avpih";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const os = "UserAgentBadge__os__B8sBk";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const value = "UserAgentBadge__value__kBXOa";